import { LayoutComponent } from "../../../components";
import { Outlet } from "react-router-dom";

export function LaboratoryLayout() {
  return (
    <LayoutComponent selectedMenuItem={"laboratory"}>
      <Outlet />
    </LayoutComponent>
  );
}
